import * as React from 'react';

const IntegrationsIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={16}>
    <path
      fill={fillColor}
      d="M5.05 14.667h1.9v-1.823l3.55-3.466V5.133h-9v4.245l3.55 3.46v1.829Zm-1.5-1.29L.4 10.29a1.232 1.232 0 0 1-.296-.405A1.16 1.16 0 0 1 0 9.4V5.133c0-.366.147-.68.44-.941A1.54 1.54 0 0 1 1.5 3.8h1.8l-.75.667v-3.8c0-.19.072-.348.217-.475A.782.782 0 0 1 3.304 0c.214 0 .392.064.534.192a.614.614 0 0 1 .212.475V3.8h3.9V.667c0-.19.072-.348.217-.475A.782.782 0 0 1 8.704 0c.214 0 .392.064.534.192a.614.614 0 0 1 .212.475v3.8L8.7 3.8h1.8c.412 0 .766.13 1.06.392.293.26.44.575.44.941V9.4c0 .17-.035.33-.104.484-.07.154-.169.288-.296.405l-3.15 3.089v1.955a.61.61 0 0 1-.216.475A.775.775 0 0 1 7.7 16H4.3a.775.775 0 0 1-.534-.192.61.61 0 0 1-.216-.475v-1.955Z"
    />
  </svg>
);

export default IntegrationsIcon;
